import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionChangeRejectionReason from "./exemptionChangeRejectionReason";
import type ExemptionChangeWarningReason from "./exemptionChangeWarningReason";
import VehicleResponse from "./vehicleResponse";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionChangePreviewResponse {
  /**
   * If true - exemption can be changed.
   */
  @observable
  canBeChanged!: boolean;

  /**
   * Creation record ID.
   */
  @observable
  creationRecordId!: string;

  /**
   * Cancellation official record ID.
   */
  @observable
  cancellationRecordId?: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId?: string;

  @observable
  vehicleClassifiedFuelType?: VehicleRegisterVehicleClassifiedFuelType;

  /**
   * Cancellation reason.
   */
  @observable
  cancellationReason?: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Exemption reason ID.
   */
  @observable
  exemptionReasonId!: string;

  /**
   * Exemption is valid since this date and time.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Exemption is valid until this date and time.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  rejectionReason?: ExemptionChangeRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: ExemptionChangeWarningReason[];
}
